import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchIpAddress, getLocationCoordinates } from '../../utils/helper';
import { message } from 'antd';
import './style.css';

const WaterMark = () => {
    const user = useSelector((state) => state.editor.userInformation);
    const [userLocation, setUserLocation] = useState({
        ip: "",
        location: {
            lat: "",
            lng: "",
        },
    });

    const [loading, setLoading] = useState(true);
    const [currentDateTime, setCurrentDateTime] = useState("");

    const getUserLocationSuccess = (location) => {
        setUserLocation((prevState) => ({
            ...prevState,
            location: {
                lat: location.coords.latitude,
                lng: location.coords.longitude,
            },
        }));
    };

    const getUserLocationError = (error) => {
        if (error.code === 1) {
            // User denied geolocation access
            console.error("User denied Geolocation:", error.message);
            message.error("We were unable to access your location. Please allow location access to proceed.");
        } else if (error.code === 2) {
            // Location unavailable (e.g., no GPS signal)
            console.error("Location unavailable:", error.message);
            message.error("Unable to determine your location. Please check your connection or GPS settings.");
        } else {
            // General error (other codes)
            console.error("Geolocation error:", error.message);
            message.error("An error occurred while retrieving your location. Please try again.");
        }
        setLoading(false);
    };

    const getIpAddress = async () => {
        try {
            const response = await fetchIpAddress();
            setUserLocation((prevState) => ({
                ...prevState,
                ip: response,
            }));
        } catch (error) {
            console.error("Error fetching IP address:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getLocationCoordinates(getUserLocationSuccess, getUserLocationError);
        getIpAddress();
        const now = new Date();
        setCurrentDateTime(now.toLocaleString());
    }, []);

    if (loading) {
        return null;
    }

    const totalPages = document.querySelectorAll('.page-break[data-page-number]').length + 2;
    const watermarksPerPage = 3;
    const watermarkHeight = 400;
    const watermarkSpacing = 800;

    return (
        <div className='Water-mark'>
            {
                Array(totalPages)
                    .fill(0)
                    .map((_, pageIndex) => (
                        // For each page, show 3 watermarks
                        <div key={pageIndex}>
                            {Array(watermarksPerPage)
                                .fill(0)
                                .map((_, watermarkIndex) => {
                                    const watermarkTop = (pageIndex * watermarkSpacing) + watermarkIndex * watermarkHeight + 80;
                                    return (
                                        <div
                                            key={watermarkIndex}
                                            className="watermark-style"
                                            style={{ top: `${watermarkTop}px` }}
                                        >
                                            <div>Username: {user.name}</div>
                                            {
                                                !!userLocation.location.lat &&
                                                <div>
                                                    Location: {userLocation.location.lat}, {userLocation.location.lng}
                                                </div>}
                                            <div>IP: {userLocation.ip}</div>
                                            <div>Time: {currentDateTime}</div>
                                        </div>
                                    );
                                })}
                        </div>
                    ))
            }
        </div>
    );
};

export default WaterMark;
